export default "__VITE_ASSET__cgAH8735P5Ns3szwKs$5Bw__"